import Link from "next/link";
import { usePathname } from "next/navigation";
import React, { useState } from "react";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import { NumericFormat } from "react-number-format";

const FormField = (props) => {
  const [isPassword, setPasswordType] = useState(true);
  const pathName = usePathname();
  const {
    label,
    name,
    type,
    placeholder,
    error,
    register,
    change = false,
    signin = false,
    ...otherProps
  } = props;

  return (
    <div className="mb-3">
      <div
        className={`flex ${
          change ? "justify-between" : "just-fy-start"
        } items-center my-1`}
      >
        <label className="font-medium text-black">{label}</label>
        {change && signin && !pathName.includes("verify-account") && (
          <Link className="text-primary text-sm font-semibold" href={"/forgot"}>
            Forgot Password?
          </Link>
        )}
      </div>
      {type === "money" ? (
        <NumericFormat
          suffix={props.suffix}
          prefix={props.prefix}
          valueIsNumericString={true}
          name="amount"
          className={`rounded-md flex  item-center justify-between outline-none focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 bg-white w-full h-12 border border-black py-2 px-3
          ${props.inputClass}`}
          disabled={props.isDisabled}
          placeholder={placeholder}
          thousandSeparator={props.thousandSeparator}
          decimalSeparator={props.decimalSeparator}
          allowNegative={false}
          autoComplete={props.autoComplete}
          max={props.max}
          min={props.min}
          onKeyUp={props.onKeyUp}
          {...otherProps}
        />
      ) : type === "textarea" ? (
        <div className="rounded-md flex item-center justify-between outline-none focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 bg-white w-full border border-black py-2 px-3">
          <textarea
            className="outline-none border-0 w-full"
            name={name}
            placeholder={placeholder}
            rows={8}
            {...otherProps}
          />
        </div>
      ) : (
        <div className="rounded-md flex  item-center justify-between outline-none focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 bg-white w-full h-12  border border-black py-2 px-3">
          <input
            type={isPassword ? type : "text"}
            className={`outline-none border-0 ${change ? "w-[90%]" : "w-full"}`}
            name={name}
            placeholder={placeholder}
            {...otherProps}
          />
          {change && (
            <span
              onClick={() => setPasswordType(!isPassword)}
              className="pt-2 cursor-pointer"
            >
              {isPassword ? (
                <BsEyeSlashFill size={18} color="#BDBCC0" />
              ) : (
                <BsEyeFill size={18} color="#BDBCC0" />
              )}
            </span>
          )}
        </div>
      )}
      {error && (
        <span className="text-danger text-xs my-1.5 font-semibold text-wrap">
          {error.message}
        </span>
      )}
    </div>
  );
};

export default FormField;
